// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Off-table landscape — station lane board (not a table duel). */

.lt-otl {
  --lt-otl-ink: #e8eef7;
  --lt-otl-muted: rgba(232, 238, 247, 0.62);
  --lt-otl-line: rgba(232, 238, 247, 0.12);
  --lt-otl-panel: rgba(10, 18, 32, 0.55);
  --lt-otl-lane: rgba(255, 255, 255, 0.04);
  --lt-otl-rec: #dc2626;
  --lt-otl-you: #fde68a;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  color: var(--lt-otl-ink);
  background:
    radial-gradient(120% 80% at 0% 0%, rgba(8, 119, 188, 0.18), transparent 55%),
    radial-gradient(90% 70% at 100% 100%, rgba(70, 82, 139, 0.22), transparent 50%),
    linear-gradient(160deg, #071018 0%, #0d1726 48%, #101a2a 100%);
}

.lt-otl--cam-live {
  box-shadow: inset 0 0 0 2px rgba(220, 38, 38, 0.35);
}

.lt-otl__board {
  flex: 1 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(160px, 0.9fr) minmax(0, 1.5fr) minmax(170px, 0.95fr);
  gap: 10px;
  padding: 8px 10px 10px;
}

.lt-otl__exercise,
.lt-otl__lanes,
.lt-otl__you-panel {
  min-width: 0;
  min-height: 0;
  border: 1px solid var(--lt-otl-line);
  border-radius: 14px;
  background: var(--lt-otl-panel);
  backdrop-filter: blur(8px);
}

.lt-otl__exercise {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 14px;
}

.lt-otl__exercise-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.lt-otl__logo {
  width: 36px;
  height: 36px;
  object-fit: contain;
}

.lt-otl__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.68rem;
  font-weight: 750;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--lt-otl-muted);
}

.lt-otl__eyebrow .MuiSvgIcon-root {
  font-size: 0.9rem;
}

.lt-otl__title {
  margin: 0;
  font-size: clamp(1rem, 2.2vw, 1.45rem);
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.02em;
}

.lt-otl__meta {
  margin: 0;
  font-size: 0.78rem;
  color: var(--lt-otl-muted);
  line-height: 1.3;
}

.lt-otl__status {
  align-self: flex-start;
  margin-top: auto;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 750;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.lt-otl__status--live {
  background: rgba(34, 197, 94, 0.2);
  color: #86efac;
}

.lt-otl__status--pause {
  background: rgba(251, 191, 36, 0.18);
  color: #fde68a;
}

.lt-otl__status--wait {
  background: rgba(148, 163, 184, 0.18);
  color: #cbd5e1;
}

.lt-otl__mode-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.lt-otl__pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 700;
  border: 1px solid var(--lt-otl-line);
  color: var(--lt-otl-muted);
}

.lt-otl__pill .MuiSvgIcon-root {
  font-size: 0.85rem;
}

.lt-otl__pill--chrono {
  color: #7dd3fc;
  border-color: rgba(125, 211, 252, 0.35);
}

.lt-otl__pill--count {
  color: #fcd34d;
  border-color: rgba(252, 211, 77, 0.35);
}

.lt-otl__lanes {
  display: flex;
  flex-direction: column;
  padding: 10px 10px 8px;
  overflow: hidden;
}

.lt-otl__lanes-head {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
  padding: 0 6px 8px;
  font-size: 0.66rem;
  font-weight: 750;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--lt-otl-muted);
  border-bottom: 1px solid var(--lt-otl-line);
}

.lt-otl__empty {
  margin: auto;
  padding: 16px;
  text-align: center;
  font-size: 0.85rem;
  color: var(--lt-otl-muted);
}

.lt-otl__list {
  margin: 0;
  padding: 6px 0 0;
  list-style: none;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-height: 0;
}

.lt-otl__lane {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  padding: 8px 8px;
  border-radius: 10px;
  background: var(--lt-otl-lane);
  border: 1px solid transparent;
  transition: background 160ms ease, border-color 160ms ease;
}

.lt-otl__lane--mine {
  border-color: rgba(253, 230, 138, 0.45);
  background: rgba(253, 230, 138, 0.08);
}

.lt-otl__lane--running {
  background: rgba(8, 119, 188, 0.22);
}

.lt-otl__lane--rec {
  border-color: rgba(248, 113, 113, 0.7);
  background: rgba(220, 38, 38, 0.22);
  animation: lt-otl-lane-rec 1.4s ease-in-out infinite;
}

.lt-otl__lane-order {
  width: 24px;
  height: 24px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.72rem;
  font-weight: 800;
  background: rgba(255, 255, 255, 0.08);
}

.lt-otl__lane-name {
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.92rem;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lt-otl__you {
  flex-shrink: 0;
  padding: 1px 6px;
  border-radius: 999px;
  font-size: 0.58rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #1f2937;
  background: var(--lt-otl-you);
}

.lt-otl__rec {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 1px 6px 1px 4px;
  border-radius: 999px;
  font-size: 0.58rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  color: #fff;
  background: var(--lt-otl-rec);
  animation: lt-otl-rec-pulse 1.2s ease-in-out infinite;
}

.lt-otl__rec::before {
  content: "";
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #fff;
}

.lt-otl__rec--lg {
  font-size: 0.7rem;
  padding: 2px 8px 2px 6px;
}

.lt-otl__lane-metric {
  font-variant-numeric: tabular-nums;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 1rem;
  font-weight: 750;
  letter-spacing: 0.03em;
}

.lt-otl__you-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 6px;
  padding: 14px 12px;
  position: relative;
  overflow: hidden;
}

.lt-otl__you-panel::before {
  content: "";
  position: absolute;
  inset: auto -20% -40% -20%;
  height: 70%;
  background: radial-gradient(circle, rgba(8, 119, 188, 0.28), transparent 65%);
  pointer-events: none;
}

.lt-otl__you-panel--rec {
  border-color: rgba(248, 113, 113, 0.65);
  box-shadow: inset 0 0 0 1px rgba(220, 38, 38, 0.35);
}

.lt-otl__you-panel--rec::before {
  background: radial-gradient(circle, rgba(220, 38, 38, 0.32), transparent 65%);
}

.lt-otl__you-label {
  position: relative;
  z-index: 1;
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.78rem;
  font-weight: 750;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--lt-otl-muted);
}

.lt-otl__you-metric {
  position: relative;
  z-index: 1;
  margin: 0;
  font-size: clamp(2.4rem, 7vw, 3.6rem);
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.03em;
  font-variant-numeric: tabular-nums;
}

.lt-otl__you-metric--clock {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: clamp(1.7rem, 5.2vw, 2.6rem);
  letter-spacing: 0.02em;
}

.lt-otl__you-caption {
  position: relative;
  z-index: 1;
  margin: 0;
  font-size: 0.78rem;
  color: var(--lt-otl-muted);
}

.lt-otl__cam-hint {
  position: relative;
  z-index: 1;
  margin: 4px 0 0;
  font-size: 0.68rem;
  font-weight: 650;
  color: #fca5a5;
}

@keyframes lt-otl-rec-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.55;
  }
}

@keyframes lt-otl-lane-rec {
  0%,
  100% {
    box-shadow: inset 0 0 0 1px rgba(248, 113, 113, 0.35);
  }
  50% {
    box-shadow: inset 0 0 0 1px rgba(248, 113, 113, 0.8);
  }
}

@media (prefers-reduced-motion: reduce) {
  .lt-otl__rec,
  .lt-otl__lane--rec {
    animation: none;
  }
}

@media (max-height: 420px) {
  .lt-otl__board {
    gap: 6px;
    padding: 4px 8px 8px;
  }

  .lt-otl__exercise {
    padding: 8px 10px;
  }

  .lt-otl__you-metric {
    font-size: clamp(1.8rem, 5vw, 2.6rem);
  }

  .lt-otl__you-metric--clock {
    font-size: clamp(1.3rem, 4vw, 1.9rem);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/LiveTrainingOffTableLandscape.css"],"names":[],"mappings":"AAAA,iEAAiE;;AAEjE;EACE,qBAAqB;EACrB,yCAAyC;EACzC,wCAAwC;EACxC,sCAAsC;EACtC,wCAAwC;EACxC,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB;;;kEAGgE;AAClE;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,kFAAkF;EAClF,SAAS;EACT,sBAAsB;AACxB;;AAEA;;;EAGE,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,sCAAsC;EACtC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;EAC7B,0DAA0D;AAC5D;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,6BAA6B;EAC7B,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,6EAA6E;EAC7E,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,mDAAmD;AACrD;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,6EAA6E;EAC7E,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,qDAAqD;EACvD;EACA;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,QAAQ;IACR,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;AACF","sourcesContent":["/* Off-table landscape — station lane board (not a table duel). */\n\n.lt-otl {\n  --lt-otl-ink: #e8eef7;\n  --lt-otl-muted: rgba(232, 238, 247, 0.62);\n  --lt-otl-line: rgba(232, 238, 247, 0.12);\n  --lt-otl-panel: rgba(10, 18, 32, 0.55);\n  --lt-otl-lane: rgba(255, 255, 255, 0.04);\n  --lt-otl-rec: #dc2626;\n  --lt-otl-you: #fde68a;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  color: var(--lt-otl-ink);\n  background:\n    radial-gradient(120% 80% at 0% 0%, rgba(8, 119, 188, 0.18), transparent 55%),\n    radial-gradient(90% 70% at 100% 100%, rgba(70, 82, 139, 0.22), transparent 50%),\n    linear-gradient(160deg, #071018 0%, #0d1726 48%, #101a2a 100%);\n}\n\n.lt-otl--cam-live {\n  box-shadow: inset 0 0 0 2px rgba(220, 38, 38, 0.35);\n}\n\n.lt-otl__board {\n  flex: 1;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: minmax(160px, 0.9fr) minmax(0, 1.5fr) minmax(170px, 0.95fr);\n  gap: 10px;\n  padding: 8px 10px 10px;\n}\n\n.lt-otl__exercise,\n.lt-otl__lanes,\n.lt-otl__you-panel {\n  min-width: 0;\n  min-height: 0;\n  border: 1px solid var(--lt-otl-line);\n  border-radius: 14px;\n  background: var(--lt-otl-panel);\n  backdrop-filter: blur(8px);\n}\n\n.lt-otl__exercise {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px 14px;\n}\n\n.lt-otl__exercise-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.lt-otl__logo {\n  width: 36px;\n  height: 36px;\n  object-fit: contain;\n}\n\n.lt-otl__eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.68rem;\n  font-weight: 750;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--lt-otl-muted);\n}\n\n.lt-otl__eyebrow .MuiSvgIcon-root {\n  font-size: 0.9rem;\n}\n\n.lt-otl__title {\n  margin: 0;\n  font-size: clamp(1rem, 2.2vw, 1.45rem);\n  font-weight: 800;\n  line-height: 1.15;\n  letter-spacing: -0.02em;\n}\n\n.lt-otl__meta {\n  margin: 0;\n  font-size: 0.78rem;\n  color: var(--lt-otl-muted);\n  line-height: 1.3;\n}\n\n.lt-otl__status {\n  align-self: flex-start;\n  margin-top: auto;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 750;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.lt-otl__status--live {\n  background: rgba(34, 197, 94, 0.2);\n  color: #86efac;\n}\n\n.lt-otl__status--pause {\n  background: rgba(251, 191, 36, 0.18);\n  color: #fde68a;\n}\n\n.lt-otl__status--wait {\n  background: rgba(148, 163, 184, 0.18);\n  color: #cbd5e1;\n}\n\n.lt-otl__mode-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.lt-otl__pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 8px;\n  border-radius: 999px;\n  font-size: 0.68rem;\n  font-weight: 700;\n  border: 1px solid var(--lt-otl-line);\n  color: var(--lt-otl-muted);\n}\n\n.lt-otl__pill .MuiSvgIcon-root {\n  font-size: 0.85rem;\n}\n\n.lt-otl__pill--chrono {\n  color: #7dd3fc;\n  border-color: rgba(125, 211, 252, 0.35);\n}\n\n.lt-otl__pill--count {\n  color: #fcd34d;\n  border-color: rgba(252, 211, 77, 0.35);\n}\n\n.lt-otl__lanes {\n  display: flex;\n  flex-direction: column;\n  padding: 10px 10px 8px;\n  overflow: hidden;\n}\n\n.lt-otl__lanes-head {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 8px;\n  padding: 0 6px 8px;\n  font-size: 0.66rem;\n  font-weight: 750;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--lt-otl-muted);\n  border-bottom: 1px solid var(--lt-otl-line);\n}\n\n.lt-otl__empty {\n  margin: auto;\n  padding: 16px;\n  text-align: center;\n  font-size: 0.85rem;\n  color: var(--lt-otl-muted);\n}\n\n.lt-otl__list {\n  margin: 0;\n  padding: 6px 0 0;\n  list-style: none;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-height: 0;\n}\n\n.lt-otl__lane {\n  display: grid;\n  grid-template-columns: 28px minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 8px;\n  border-radius: 10px;\n  background: var(--lt-otl-lane);\n  border: 1px solid transparent;\n  transition: background 160ms ease, border-color 160ms ease;\n}\n\n.lt-otl__lane--mine {\n  border-color: rgba(253, 230, 138, 0.45);\n  background: rgba(253, 230, 138, 0.08);\n}\n\n.lt-otl__lane--running {\n  background: rgba(8, 119, 188, 0.22);\n}\n\n.lt-otl__lane--rec {\n  border-color: rgba(248, 113, 113, 0.7);\n  background: rgba(220, 38, 38, 0.22);\n  animation: lt-otl-lane-rec 1.4s ease-in-out infinite;\n}\n\n.lt-otl__lane-order {\n  width: 24px;\n  height: 24px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.72rem;\n  font-weight: 800;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.lt-otl__lane-name {\n  min-width: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.92rem;\n  font-weight: 700;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.lt-otl__you {\n  flex-shrink: 0;\n  padding: 1px 6px;\n  border-radius: 999px;\n  font-size: 0.58rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #1f2937;\n  background: var(--lt-otl-you);\n}\n\n.lt-otl__rec {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 1px 6px 1px 4px;\n  border-radius: 999px;\n  font-size: 0.58rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  color: #fff;\n  background: var(--lt-otl-rec);\n  animation: lt-otl-rec-pulse 1.2s ease-in-out infinite;\n}\n\n.lt-otl__rec::before {\n  content: \"\";\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: #fff;\n}\n\n.lt-otl__rec--lg {\n  font-size: 0.7rem;\n  padding: 2px 8px 2px 6px;\n}\n\n.lt-otl__lane-metric {\n  font-variant-numeric: tabular-nums;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 1rem;\n  font-weight: 750;\n  letter-spacing: 0.03em;\n}\n\n.lt-otl__you-panel {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 6px;\n  padding: 14px 12px;\n  position: relative;\n  overflow: hidden;\n}\n\n.lt-otl__you-panel::before {\n  content: \"\";\n  position: absolute;\n  inset: auto -20% -40% -20%;\n  height: 70%;\n  background: radial-gradient(circle, rgba(8, 119, 188, 0.28), transparent 65%);\n  pointer-events: none;\n}\n\n.lt-otl__you-panel--rec {\n  border-color: rgba(248, 113, 113, 0.65);\n  box-shadow: inset 0 0 0 1px rgba(220, 38, 38, 0.35);\n}\n\n.lt-otl__you-panel--rec::before {\n  background: radial-gradient(circle, rgba(220, 38, 38, 0.32), transparent 65%);\n}\n\n.lt-otl__you-label {\n  position: relative;\n  z-index: 1;\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.78rem;\n  font-weight: 750;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--lt-otl-muted);\n}\n\n.lt-otl__you-metric {\n  position: relative;\n  z-index: 1;\n  margin: 0;\n  font-size: clamp(2.4rem, 7vw, 3.6rem);\n  font-weight: 800;\n  line-height: 1;\n  letter-spacing: -0.03em;\n  font-variant-numeric: tabular-nums;\n}\n\n.lt-otl__you-metric--clock {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: clamp(1.7rem, 5.2vw, 2.6rem);\n  letter-spacing: 0.02em;\n}\n\n.lt-otl__you-caption {\n  position: relative;\n  z-index: 1;\n  margin: 0;\n  font-size: 0.78rem;\n  color: var(--lt-otl-muted);\n}\n\n.lt-otl__cam-hint {\n  position: relative;\n  z-index: 1;\n  margin: 4px 0 0;\n  font-size: 0.68rem;\n  font-weight: 650;\n  color: #fca5a5;\n}\n\n@keyframes lt-otl-rec-pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.55;\n  }\n}\n\n@keyframes lt-otl-lane-rec {\n  0%,\n  100% {\n    box-shadow: inset 0 0 0 1px rgba(248, 113, 113, 0.35);\n  }\n  50% {\n    box-shadow: inset 0 0 0 1px rgba(248, 113, 113, 0.8);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .lt-otl__rec,\n  .lt-otl__lane--rec {\n    animation: none;\n  }\n}\n\n@media (max-height: 420px) {\n  .lt-otl__board {\n    gap: 6px;\n    padding: 4px 8px 8px;\n  }\n\n  .lt-otl__exercise {\n    padding: 8px 10px;\n  }\n\n  .lt-otl__you-metric {\n    font-size: clamp(1.8rem, 5vw, 2.6rem);\n  }\n\n  .lt-otl__you-metric--clock {\n    font-size: clamp(1.3rem, 4vw, 1.9rem);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
